import { render, staticRenderFns } from "./InstrumentDetailsModal.vue?vue&type=template&id=2b794bee&scoped=true"
import script from "./InstrumentDetailsModal.vue?vue&type=script&lang=js"
export * from "./InstrumentDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./InstrumentDetailsModal.vue?vue&type=style&index=0&id=2b794bee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b794bee",
  null
  
)

export default component.exports